var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('h4',[_vm._v("New Smart Link")]),_c('Campaign',{attrs:{"onSubmit":_vm.submit,"isVta":_vm.isVta}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }